export const modalMotionPresets = {
  default: 'default',
  none: 'none',
} as const;

export type ModalMotionPreset = (typeof modalMotionPresets)[keyof typeof modalMotionPresets];

export const getModalCloseDelay = (motionPreset: ModalMotionPreset) => (
  motionPreset === modalMotionPresets.none ? 0 : 200
);
